import { resetCf7ModalSuccess } from "./cf7-modal-response.js";

function parseHashes(modal) {
  const raw = modal.getAttribute("data-modal-hashes") || "#pasiulymas";
  return raw
    .split(",")
    .map((part) => part.trim().toLowerCase())
    .filter(Boolean)
    .map((part) => (part.startsWith("#") ? part : `#${part}`));
}

function normalizeHash(hash) {
  if (!hash) {
    return "";
  }
  const value = hash.trim().toLowerCase();
  return value.startsWith("#") ? value : `#${value}`;
}

export default function initGlobalModal(root = document) {
  const scope = root && root.querySelectorAll ? root : document;
  const modal = scope.querySelector("[data-global-modal]");

  if (!modal || modal.__globalModalBound) {
    return;
  }

  modal.__globalModalBound = true;

  const hashTriggers = new Set(parseHashes(modal));
  const closeButtons = modal.querySelectorAll("[data-global-modal-close]");
  let lastActiveElement = null;

  const isTriggerHref = (href) => {
    if (!href) {
      return false;
    }
    const normalized = normalizeHash(href);
    return hashTriggers.has(normalized);
  };

  const openModal = () => {
    resetCf7ModalSuccess(modal);
    lastActiveElement = document.activeElement;
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    modal.classList.add("is-open");
    document.documentElement.classList.add("global-modal-open");

    const focusable = modal.querySelector(
      "button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])",
    );
    if (focusable && typeof focusable.focus === "function") {
      focusable.focus();
    }
  };

  const closeModal = () => {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    modal.hidden = true;
    document.documentElement.classList.remove("global-modal-open");

    if (window.location.hash && hashTriggers.has(normalizeHash(window.location.hash))) {
      history.replaceState(null, "", window.location.pathname + window.location.search);
    }

    if (lastActiveElement && typeof lastActiveElement.focus === "function") {
      lastActiveElement.focus();
    }
  };

  const openFromHash = () => {
    if (isTriggerHref(window.location.hash)) {
      openModal();
    }
  };

  scope.addEventListener("click", (event) => {
    const trigger = event.target.closest("a[href], [data-global-modal-open]");
    if (!trigger || !document.body.contains(trigger)) {
      return;
    }

    if (trigger.hasAttribute("data-global-modal-open")) {
      event.preventDefault();
      openModal();
      return;
    }

    const href = trigger.getAttribute("href") || "";
    if (isTriggerHref(href)) {
      event.preventDefault();
      openModal();
    }
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      closeModal();
    });
  });

  document.addEventListener("keydown", (event) => {
    if (!modal.classList.contains("is-open")) {
      return;
    }
    if (event.key === "Escape") {
      event.preventDefault();
      closeModal();
    }
  });

  window.addEventListener("hashchange", openFromHash);

  if (isTriggerHref(window.location.hash)) {
    openFromHash();
  }
}
